import React, { useContext, useEffect, useState } from 'react';
import { Icons } from '../../assets';
import { Cred, Recco } from '../../models';
import { AccountContext, AccountContextInterface } from '../../contexts';
import OverlappingProfiles from './overlapping-profiles.component';

type Props = {
  cred: Cred;
  handleCredDetailsClicked: () => void;
};

export const CredReccoDetails: React.FC<Props> = ({ cred, handleCredDetailsClicked }) => {
  const [reccos, setReccos] = useState<Recco[]>();
  const { accountService } = useContext<AccountContextInterface>(AccountContext);

  useEffect(() => {
    if (cred?.id) {
      fetchReccos();
    }
  }, [cred?.id])

  const fetchReccos = async () => {
    const res = await accountService.getCredReccos(cred?.id);
    setReccos(res.data);
  }

  return (
    <div className="d-flex align-items-center gap-1"
      onClick={handleCredDetailsClicked}
    >
      {reccos && <><OverlappingProfiles collaborators={reccos.map(cl => cl.createdBy)} size={22}/>
      <span style={{ fontSize: '14px', fontWeight: 500 }}>
        {cred?.reccoCount}
      </span>
      <img
          className="rounded-circle"
          style={{ width: '22px', height: '22px' }}
          src={Icons.BLUE_RECCO}
          alt="Creator"
        /></>}
    </div>
  );
};
